/**
 * Hash email using SHA-256 for PII protection
 * Follows Google's email normalization specifications for GTM
 */
export const hashEmail = async (email: string): Promise<string | undefined> => {
  try {
    // Remove leading and trailing whitespace and convert to lowercase
    let normalizedEmail = email.toLowerCase().trim();

    // Remove all periods from the local part (before @) for gmail.com and googlemail.com
    const [localPart, domain] = normalizedEmail.split("@");
    if (domain === "gmail.com" || domain === "googlemail.com") {
      normalizedEmail = localPart.replace(/\./g, "") + "@" + domain;
    }

    // Convert string to Uint8Array
    const encoder = new TextEncoder();
    const data = encoder.encode(normalizedEmail);

    // Hash using SHA-256
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);

    // Convert buffer to hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
      .map(b => b.toString(16).padStart(2, "0"))
      .join("");

    return hashHex;
  } catch (error) {
    console.error("Failed to hash email:", error);
    return undefined;
  }
};
